import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"

import { FORM_URL } from 'app/@common/constants'


export default function SelectNights({ ...props }) {
    const myProps = {
        urlAjax: FORM_URL.NIGHTS,
        isMulti: true,
        icon: { icon: 'moon-stars' },
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}